module.exports = __webpack_public_path__ + "static/media/VisbyCF-Bold.f4f37aa9.woff2";